import axios from "axios";

export interface TermsResponse {
  title: string;
  content: string;
}

export async function getTicketGoatTerms(): Promise<TermsResponse> {
  const res = await axios.get<TermsResponse>("/api/terms/ticket-goat");
  return res.data;
}

export async function getVenueTerms(venueId: number): Promise<TermsResponse> {
  const res = await axios.get<TermsResponse>(`/api/terms/venue/${venueId}`);
  return res.data;
}
